<template>
  <div class="text-center px-3 py-10 flex flex-col gap-8">
    <h2 class="uppercase font-bold text-3xl">
      {{ $t('tickets.success_title') }}
    </h2>
    <div class="text-gray-900 text-lg">
      {{ $t('tickets.success_subtitle_invoice') }}
    </div>
    <div class="flex gap-4 justify-center items-center">
      <BaseLocaleLink v-if="orderRoute" :to="orderRoute">
        <BaseButton size="lg">
          {{ $t('tickets.check_order') }}
        </BaseButton>
      </BaseLocaleLink>
    </div>
    <div class="text-sm">
      {{ $t('tickets.success_description') }}
      <BaseLink
        :href="`mailto:${email}`"
        class="inline-flex space-x-2 items-center"
      >
        {{ email }}
      </BaseLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

interface PropsInterface {
  orderRoute?: string | RouteLocationRaw
}

withDefaults(defineProps<PropsInterface>(), {
  orderRoute: '',
})

const { email } = useStaticData()
</script>
